// Tiny helper that pairs an auto-dismiss timeout with each in-panel
// toast. Replaces the five copies of the same useEffect that piled up
// in ManufacturingInventoryPanel after the Receive merge folded the
// receive-side toast handling in next to inventory's create/update/
// import/recipe-count handlers.
import { useEffect } from "react";

export function useAutoDismissToast(
  toast: string | null | undefined,
  dismiss: () => void,
  ms = 2400
) {
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(dismiss, ms);
    return () => window.clearTimeout(t);
  }, [toast, dismiss, ms]);
}
